import { dispatch } from 'nike-re-framejs';
import './handlers';
import './subs';
import { userDataUpdated } from './handlers';
import { loadNewAccountMessages } from '@/message/handlers';

export function isLoggedIn() {
    return !!window.USER_DATA_SNAPSHOT.cisloZmluvy;
}

export function initializeAccountSnapshot(db) {
    dispatch(loadNewAccountMessages);
    return db.update(userDataUpdated(window.USER_DATA_SNAPSHOT));
}

let lastAccountSync = new Date().getTime();
const syncAccountInterval = 60 * 1000;

export function scheduleAccountUpdating(db) {
    scheduleUpdating(db.get('loggedIn'));
    return db;
}

function scheduleUpdating(loggedIn) {
    setInterval(() => {
        const now = new Date().getTime();
        // account data
        if (loggedIn) {
            if (now - lastAccountSync > syncAccountInterval) {
                lastAccountSync = now;
                dispatch(['account.updateUserData']);
            }
        }
    }, 4000);
}
